
import { defineComponent } from 'vue'
import BaseMenuBar from '@madxnl/mrrabbit/dist/MenuBar'

export default defineComponent({
  ...(BaseMenuBar as any),
  computed: {
    ...(BaseMenuBar as any).computed,
    items() {
      return (this as any).config.map((item: { name: string }) => ({
        label: item.name,
        to: { name: item.name },
      }))
    },
  },
})
